import { render, staticRenderFns } from "./vpl-detach-modal.vue?vue&type=template&id=2d9fa2bc&scoped=true&"
import script from "./vpl-detach-modal.vue?vue&type=script&lang=js&"
export * from "./vpl-detach-modal.vue?vue&type=script&lang=js&"
import style0 from "./vpl-detach-modal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./vpl-detach-modal.vue?vue&type=style&index=1&id=2d9fa2bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9fa2bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VSpacer,VTextField})
